import { Pipe, PipeTransform } from '@angular/core';
import {IHolidayDetailSolution} from '../holiday-detail-page/interfaces/iholiday-detail-solution';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'holidayBestSolution'
})
export class HolidayBestSolutionPipe implements PipeTransform {
  transform(solutions: IHolidayDetailSolution[], date: Date, departurePlaceId ): IHolidayDetailSolution {
    return solutions
      ?.filter( (solution: IHolidayDetailSolution) => dayjs( solution.dateFrom).isSame(date, 'day'))
      ?.filter( (solution: IHolidayDetailSolution) => departurePlaceId ? solution.airport === departurePlaceId : !solution.airport )
      ?.sort( (solutionA: IHolidayDetailSolution, solutionB:IHolidayDetailSolution) => solutionA.price - solutionB.price)
      ?.find( (solutions:IHolidayDetailSolution) => solutions ) //first
  }
}
